import { useState, useEffect } from 'react'
import { useSpring, animated } from 'react-spring'
import { getStringWidth } from '@visx/text'

import { useStyles } from './static-marker.style'
import { colors } from '#base/js/variables.style'

export function StaticMarker ({ label, value, scale, height, selectedX }) {
  const classes = useStyles()
  const [showMarker, setShowMarker] = useState(true)

  const springProps = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    reverse: !showMarker
  })

  const valuePosition = scale(value)

  useEffect(() => {
    if (selectedX !== undefined) {
      const xSelectedPosition = scale(selectedX)
      const labelWidth = getStringWidth(label)
      const lineMarkerPadding = (labelWidth * 1.5) / 2
      const left = valuePosition - lineMarkerPadding
      const right = valuePosition + lineMarkerPadding
      const shouldShowMarker = (xSelectedPosition > right) || (xSelectedPosition < left)
      setShowMarker(shouldShowMarker)
    }
  }, [label, value, scale, selectedX, valuePosition])

  if (value === undefined) {
    return null
  }

  return (
    <g data-qa="static-marker-vertical">
      <animated.text className={classes.text} y={-7} x={valuePosition} style={springProps}>
        {label}
      </animated.text>
      <line
        y1={0}
        y2={height}
        stroke={colors.brandDark}
        strokeWidth={1}
        strokeDasharray="5,4"
        x1={valuePosition}
        x2={valuePosition} />
    </g>
  )
}
